package com.oratakashi.web.utils

import kotlin.js.Date
import kotlin.math.abs
import kotlin.random.Random

object Utility {
    val likeCount: String
        get() = Random.nextInt(1000, 999999)
            .prettyCount()

    val currentDate: String
        get() {
            val date = Date()
            return "${date.getHours()}:${date.getMinutes()} - ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}"
        }

    val currentYear: String
        get() {
            val date = Date()
            return "${date.getFullYear()}"
        }

    private fun Int.prettyCount(): String {
        return if (abs(this / 1000000) > 1) {
            (this / 1000000).toString() + "m"
        } else if (abs(this / 1000) > 1) {
            (this / 1000).toString() + "k"
        } else {
            this.toString()
        }
    }
}